<template>
  <div class="yxp-layout">
    <Head></Head>
    <div class="page-content">
      <router-view> </router-view>
    </div>
  </div>
</template>

<script>
import Head from "./Head";
import Footer from "./Footer";
export default {
  components: {
    Head,
    Footer
  },
  data() {
    return {};
  },
  computed: {
  },
  watch: {},
  methods: {},
  created() {
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.yxp-layout {
  height: 100%;
  min-height: 100%;
  position: relative;
  .page-content {
    height: 100%;
    min-height: 100%;
  }
}
</style>
